import { useGetCategorieProfessionaliQuery, useGetEsitoQuery } from "../store/services/LookUpService"

export default function CategorieProfesionaliLookUp() {
    const {data} = useGetCategorieProfessionaliQuery('');

    let optionCatProf = data?.map((esito: any) => ({value: esito?.id, label: esito?.categoria}))
    return optionCatProf;
}